// pages/RootRedirect.jsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppEnvironment } from '../hooks/useAppEnvironment';

const RootRedirect = () => {
  const { isMobile, lang } = useAppEnvironment();
  const navigate = useNavigate();

  useEffect(() => {
    if (isMobile) {
      // Redirigir a menú simplificado móvil
      navigate(`/${lang}/mobile/menu`);
    } else {
      // Redirigir a menú web normal
      navigate(`/${lang}/menu`);
    }
  }, [isMobile, lang, navigate]);

  return null; // O un spinner de carga mientras decide
};

export default RootRedirect;